module.exports = __webpack_public_path__ + "static/media/jama.31685ff6.svg";